/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Guides_ReadInputs */

const en_wc_guides_read = /** @type {(inputs: Wc_Guides_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the guide`)
};

/**
* | output |
* | --- |
* | "Read the guide" |
*
* @param {Wc_Guides_ReadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_read = /** @type {((inputs?: Wc_Guides_ReadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_ReadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_read(inputs)
});
export { wc_guides_read as "wc.guides.read" }